/**
 * Created by lhovin001c on 10/12/16.
 */

'use strict';

export var ccUtils = {
    clone: function clone(obj) {
        return JSON.parse(JSON.stringify(obj));
    },

    resolve: function resolve(path, obj) {
        var tmpMatch;

        var mTmp = [];
        // var RE2 = /(?![\[]|$)\.?([^.\[]*)(?=\.|\[|$)|(\["?[^"]*"?\])/g;
        var RE3 = /([^.[]+)|(\[[^\]]*?\])/g;
        while ((tmpMatch = RE3.exec(path)) !== null) {
            mTmp.push(tmpMatch[1] || tmpMatch[2]);
        }

        var ans2 = obj;
        for (var k = 0; k < mTmp.length; k++) {
            var idx2 = mTmp[k].indexOf('[');

            if (idx2 < 0) {
                // not found
                ans2 = ans2 ? ans2[mTmp[k]] : undefined;
            } else {
                // found - this has array notation
                // test for '[]', '[*]', '[last]', '[penultimate]', or other
                switch (mTmp[k]) {
                    case '[]':
                    case '[*]':
                        var nAns2 = [];
                        var nPath2 = mTmp.splice(k + 1).join('.');
                        for (var l = 0; l < ans2.length; l++) {
                            nAns2.push(resolve(nPath2, ans2[l]));
                        }
                        return nAns2;

                    case '[last]':
                        // test for Array
                        if (ans2 && Array.isArray(ans2)) {
                            ans2 = ans2[ans2.length - 1];
                        } else {
                            ans2 = undefined;
                        }
                        break;

                    case '[penultimate]':
                        // test for Array
                        if (ans2 && Array.isArray(ans2) && ans2.length > 1) {
                            ans2 = ans2[ans2.length - 2];
                        } else {
                            ans2 = undefined;
                        }
                        break;

                    default:
                        // remove quotes if any, process as normal
                        var innerFld = '';

                        if (mTmp[k].substr(1, 1) === '"') {
                            // remove '["' and '"]'
                            innerFld = mTmp[k].substr(2, mTmp[k].length - 4);
                        } else {
                            // remove only '[' and ']'
                            innerFld = mTmp[k].substr(1, mTmp[k].length - 2);
                        }

                        if (ans2 === undefined) {
                            console.log(mTmp);
                        }
                        ans2 = ans2[innerFld];
                }
            }
        }

        return ans2;
    },

    overlay: function overlay(oObj, nObj) {
        // enumerate through the nObj and copy properties to oObj
        Object.keys(nObj).forEach(function(prop) {
            // is nObj[prop] an object (which could be an array) treat special
            if (typeof nObj[prop] === 'object') {
                // if nObj[prop] is not an array, then recurse the objects
                if (!Array.isArray(nObj[prop])) {
                    // if oObj[prop] doesn't exist, create an empty object
                    oObj[prop] = oObj[prop] || {};
                    // recurse
                    overlay(oObj[prop], nObj[prop]);
                    return;
                }
            }
            // this is the fall through 'else' condition
            // here nObj[prop] is either a primitive or an array
            // either way, directly replace
            oObj[prop] = nObj[prop];
        });
    },

    compareObject: function compareObject(nObj, pObj, changesObj) {
        Object.keys(nObj).forEach(function(key) {
            if (typeof nObj[key] === 'object') {
                if (!compareObject(nObj[key], pObj[key], changesObj)) {
                    return false;
                }
            }

            if (nObj[key] !== pObj[key]) {
                // I want type coercion here
                return false;
            }
        });

        return true;
    },

    clearAllObjectProperties: function clearAllObjectProperties(obj) {
        Object.keys(obj).forEach(function(key) {
            delete obj[key];
        });
    },

    replaceObjectInline: function replaceObjectinline(obj, nObj) {
        ccUtils.clearAllObjectProperties(obj);

        Object.keys(nObj).forEach(function(key) {
            obj[key] = nObj[key];
        });
    },

    arrayDeDup: function arrayDeDup(array) {
        var a = array.concat();

        for (var i = 0; i < a.length; i++) {
            for (var j = i + 1; j < a.length; j++) {
                if (a[i] === a[j]) {
                    a.splice(j--, 1);
                }
            }
        }

        return a;
    },

    objectKeysSansAngular: function objectKeysSansAngular(obj) {
        // this function achieves the same goal as Object.keys(obj) except that
        // it removes keys starting with '$$' which are added by AngularJS and
        // not part of the actual data model

        var tmpKeys = Object.keys(obj);

        for (var i = tmpKeys.length; i > 0; ) {
            --i;
            if (tmpKeys[i].startsWith('$$')) {
                tmpKeys.splice(i, 1);
            }
        }

        return tmpKeys;
    },

    diffArray: function diffArray(was, is, depth) {
        was = was || [];
        is = is || [];
        if (typeof depth !== 'number') {
            depth = 1;
        }
        var removeA = was.concat();
        var addA = is.concat();
        var tmp, j, mFlg;

        for (var i = removeA.length; i > 0; ) {
            --i;
            mFlg = false;

            if (typeof removeA[i] === 'object') {
                // use diffObject/diffArray routines

                // get data for later comparison
                var keysWas = ccUtils.objectKeysSansAngular(removeA[i]);
                var idxPrimitiveProperty = 0;
                // find the idx of the first key which is not an object, it's a primitive
                while (
                    typeof removeA[i][keysWas[idxPrimitiveProperty]] ===
                    'object'
                ) {
                    idxPrimitiveProperty = idxPrimitiveProperty + 1;
                    // TODO - check for out of bounds error and ignore comparison
                    // since this object has no primitive properties
                }

                // loop thru addA to find a match
                for (j = addA.length; j > 0; ) {
                    --j;

                    tmp = [1]; // an array of 1 to cause mFlg to be false indicating no match

                    if (Array.isArray(removeA[i]) && Array.isArray(addA[j])) {
                        if (depth > 0) {
                            tmp = diffArray(removeA[i], addA[j], depth - 1);
                            // will return empty object on equal
                        } else {
                            tmp = {}; // assume match if we aren't allowed to drill down
                        }
                    } else {
                        // check that these are similar type objects before diff
                        // compare the keys of each object, only diff if they match

                        var keysIs = ccUtils.objectKeysSansAngular(addA[j]);

                        // test that all keys (object properties) match
                        if (
                            JSON.stringify(keysWas) === JSON.stringify(keysIs)
                        ) {
                            // check that the first primitive property is the same before proceeding
                            if (
                                removeA[i][
                                    keysWas[idxPrimitiveProperty] ===
                                        addA[j][keysIs[idxPrimitiveProperty]]
                                ] &&
                                depth > 0
                            ) {
                                tmp = ccUtils.diffObject(
                                    removeA[i],
                                    addA[j],
                                    depth - 1
                                );
                                // will return empty object on equal
                            } else {
                                tmp = {}; // assume match if we aren't allowed to drill down
                            }
                        }
                    }

                    mFlg = !Object.keys(tmp).length;

                    if (mFlg) {
                        // match found
                        break;
                    }
                }
            } else {
                // use indexOf() to find match
                j = addA.indexOf(removeA[i]);
                if (j === -1) {
                    mFlg = false;
                } else {
                    mFlg = true;
                }
            }

            if (mFlg) {
                // match found
                // remove removeA[i] and addA[j]
                removeA.splice(i, 1);
                addA.splice(j, 1);
            }
        }

        // if neither array contains any elements - return an empty object
        return removeA.length || addA.length
            ? { remove: removeA, add: addA, is: is, was: was }
            : {};
    },

    diffObject: function diffObject(was, is, depth) {
        was = was || {};
        is = is || {};

        if (typeof depth !== 'number') {
            depth = 1;
        }

        var diffObj = {};
        var tmp;

        var keys = ccUtils.arrayDeDup(
            ccUtils
                .objectKeysSansAngular(was)
                .concat(ccUtils.objectKeysSansAngular(is))
        );

        keys.forEach(function(key) {
            if (was[key] === undefined || is[key] === undefined) {
                diffObj[key] = { was: was[key], is: is[key] };
                return;
            }

            // if key is an object, use object/array diff functions when depth is gt zero
            if (typeof was[key] === 'object' && typeof is[key] === 'object') {
                if (depth > 0) {
                    if (Array.isArray(was[key]) && Array.isArray(is[key])) {
                        // compare as Array
                        // console.log('Comparing Arrays: ' + key);
                        tmp = ccUtils.diffArray(was[key], is[key], depth - 1);
                        if (Object.keys(tmp).length) {
                            // copy diff into diffObj;
                            diffObj[key] = tmp;
                        }
                    } else {
                        // not an Array, compare as objects
                        // console.log('Comparing Objects: ' + key);
                        tmp = diffObject(was[key], is[key], depth - 1);
                        if (Object.keys(tmp).length) {
                            diffObj[key] = tmp;
                        }
                    }
                }

                return;
            }

            // key is a primitive, compare directly
            if (was[key] !== is[key]) {
                diffObj[key] = { was: was[key], is: is[key] };
            }
        });

        return diffObj;
    },

    extend: function extend(dObj, sObj) {
        if (!dObj) {
            dObj = this;
        }

        // enumerate through the sObj and copy properties to dObj but only if they DON'T exist in dObj
        Object.keys(sObj).forEach(function(prop) {
            // is sObj[prop] an object (which could be an array) treat special
            if (typeof sObj[prop] === 'object') {
                // if sObj[prop] is not an array, then recurse the objects
                if (!Array.isArray(sObj[prop])) {
                    // if oObj[prop] doesn't exist, create an empty object
                    dObj[prop] = dObj[prop] || {};
                    // recurse
                    extend(dObj[prop], sObj[prop]);
                    return;
                }
            }
            // this is the fall through 'else' condition
            // here sObj[prop] is either a primitive or an array
            // either way, directly replace BUT only if the property doesn't already exist
            // TODO - possibly find a way to extend an Array
            if (dObj[prop] === undefined) {
                dObj[prop] = sObj[prop];
            }
            // else {
            //   console.log('Property: ' + prop + ' already exists. It\'s value is: ' + dObj[prop]);
            // }
        });
    },

    buildQuery: function buildQuery(query) {
        var qry = '';
        if (query.order) {
            var order =
                query.order[0] === '-'
                    ? query.order.substring(1) + ',desc'
                    : query.order;
            qry += '&sort=' + order;
        }
        if (query.pageSize) {
            qry += '&size=' + query.pageSize;
        }
        if (query.page) {
            qry += '&page=' + (+query.page - 1);
        }
        if (query.filters) {
            // console.log(query.filters);
            var keys = Object.keys(query.filters);
            keys.forEach(function(filter) {
                if (
                    (query.filters[filter] &&
                        query.filters[filter] !== 'all') ||
                    query.filters[filter] === false
                ) {
                    var fld = filter;
                    if (query.filterParams) {
                        fld = query.filterParams[filter] || filter;
                    }

                    // if 'filter' is an Array - convert into string values separated by comma
                    if (Array.isArray(query.filters[filter])) {
                        if (query.filters[filter].length) {
                            // only process if filters has array elements
                            var filterMethod = query.filterMethods
                                ? query.filterMethods[filter] || 'default'
                                : 'default';

                            switch (filterMethod) {
                                case 'methodB':
                                    for (
                                        var i = 0;
                                        i < query.filters[filter].length;
                                        i++
                                    ) {
                                        qry +=
                                            '&' +
                                            fld +
                                            '=' +
                                            encodeURIComponent(
                                                query.filters[filter][i]
                                            );
                                    }
                                    break;
                                default:
                                    qry +=
                                        '&' +
                                        fld +
                                        '=' +
                                        encodeURIComponent(
                                            query.filters[filter].join()
                                        );
                            }
                        }
                    } else {
                        qry +=
                            '&' +
                            fld +
                            '=' +
                            encodeURIComponent(query.filters[filter]);
                    }
                }
            });
        }
        if (query.searchActive && query.search) {
            qry += '&q=' + encodeURIComponent(query.search);
        }

        if (qry) {
            qry = '?' + qry.substring(1);
        }

        return qry;
    },

    buildQueryAsPayload: function buildQueryAsPayload(query) {
        var qry = {};
        if (query.order) {
            var order =
                query.order[0] === '-'
                    ? query.order.substring(1) + ',desc'
                    : query.order;
            qry.sort = order;
        }
        if (query.pageSize) {
            qry.size = query.pageSize;
        }
        if (query.page) {
            qry.page = +query.page - 1;
        }
        if (query.filters) {
            // console.log(query.filters);
            var keys = Object.keys(query.filters);
            keys.forEach(function(filter) {
                if (query.filters[filter] && query.filters[filter] !== 'all') {
                    var fld = filter;
                    if (query.filterParams) {
                        fld = query.filterParams[filter] || filter;
                    }

                    qry[fld] = query.filters[filter];
                }
            });
        }

        // if (query.searchActive && query.search) {
        qry.q = query.search || '';
        // }

        return qry;
    },

    buildPaginationObject: function buildPaginationObject(responseData) {
        return {
            totalPages: responseData.totalPages,
            totalElements: responseData.totalElements,
            last: responseData.last,
            numberOfElements: responseData.numberOfElements,
            sort: responseData.sort,
            first: responseData.first,
            size: responseData.size,
            number: responseData.number
        };
    },

    possessiveNounFix: function possessiveNounFix(noun) {
        if (noun.substr(-3, 1) === 's') {
            noun = noun.substr(0, noun.length - 1);
        }
        return noun;
    },

    UTCdateToAgnostic: function UTCdateToAgnostic(dt) {
        if (typeof dt === 'string') {
            dt = new Date(dt);
        }
        if (dt instanceof Date) {
            return new Date(
                dt.getUTCFullYear(),
                dt.getUTCMonth(),
                dt.getUTCDate(),
                dt.getUTCHours(),
                dt.getUTCMinutes(),
                dt.getUTCSeconds(),
                dt.getUTCMilliseconds()
            );
        }
    },

    agnosticDateToUTC: function agnosticDateToUTC(dt) {
        if (typeof dt === 'string') {
            dt = new Date(dt);
        }
        if (dt instanceof Date) {
            return new Date(
                Date.UTC(
                    dt.getFullYear(),
                    dt.getMonth(),
                    dt.getDate(),
                    dt.getHours(),
                    dt.getMinutes(),
                    dt.getSeconds(),
                    dt.getMilliseconds()
                )
            );
        }
    },

    // reference: https://stackoverflow.com/questions/1885557/simplest-code-for-array-intersection-in-javascript
    arrayIntersection: function arrayIntersection(a, b) {
        // TODO: do not use this function!! this code has a problem
        // if one of the arrays is not sorted, then it would not work
        // use lodash.intersection instead
        var ai = 0;
        var bi = 0;
        var result = [];

        while (ai < a.length && bi < b.length) {
            if (a[ai] < b[bi]) {
                ++ai;
            } else if (a[ai] > b[bi]) {
                ++bi;
            } else {
                /* they're equal */
                result.push(a[ai]);
                ++ai;
                ++bi;
            }
        }

        return result;
    },

    getObjectIdsFromArray: function getObjectIdsFromArray(objects) {
        var tmp = [];

        if (Array.isArray(objects)) {
            objects.forEach(function(obj) {
                if (obj.id) {
                    tmp.push(obj.id);
                }
            });
        }

        return tmp;
    },

    buildPatchObjectFromDiff: function buildPatchObjectFromDiff(object) {
        var tmpObj = {};

        Object.keys(object).forEach(function(key) {
            if (!key.startsWith('_')) {
                // skip properties that start with '_', these are UI internal, not part of data object
                // TODO - add flag to ignore all Array types even String Arrays

                if (
                    !Array.isArray(object[key].is) ||
                    typeof object[key].is[0] === 'string' ||
                    (object[key].is.length === 0 &&
                        object[key].was &&
                        typeof object[key].was[0] === 'string')
                ) {
                    // skip Arrays unless Arrays of strings
                    if (object[key].is) {
                        tmpObj[key] = object[key].is;
                    } else if (object[key].was) {
                        tmpObj.nullOverrides = tmpObj.nullOverrides || []; // add nullOverrides property if it doesn't exist

                        tmpObj.nullOverrides.push(key);
                    }
                }
            }
        });

        return tmpObj;
    },

    diffNonPrimitivesFromDiff: function diffNonPrimitivesFromDiff(object) {
        var tmpObj = {};

        Object.keys(object).forEach(function(key) {
            if (!key.startsWith('_')) {
                // skip properties that start with '_', these are UI internal, not part of data object
                if (
                    Array.isArray(object[key].add) &&
                    typeof object[key].add[0] === 'object'
                ) {
                    // only Arrays of Objects, empty Arrays are skipped
                    tmpObj[key] = tmpObj[key] || {};

                    if (object[key].add) {
                        tmpObj[key].add = object[key].add;
                    }
                }

                if (
                    Array.isArray(object[key].remove) &&
                    typeof object[key].remove[0] === 'object'
                ) {
                    // only Arrays of Objects, empty Arrays are skipped
                    tmpObj[key] = tmpObj[key] || {};

                    if (object[key].remove) {
                        tmpObj[key].remove = object[key].remove;
                    }
                }
            }
        });

        return tmpObj;
    },

    cmpByName: function cmpByName(a, b) {
        if (a.name < b.name) {
            return -1;
        }
        if (a.name > b.name) {
            return 1;
        }
        return 0;
        //     return a.name < b.name ? -1 : a.name > b.name ? 1 : 0;
    },

    buildChipsFromObjectFilters: function buildChipsFromFilters(object) {
        var tmp = [];

        if (object && object.query && object.query.filters) {
            var keys = Object.keys(object.query.filters);

            if (keys.length) {
                keys.forEach(function(key) {
                    if (
                        object.filterCriteria[key] &&
                        !object.filterCriteria[key].hideChip &&
                        (object.query.filters[key] ||
                            typeof object.query.filters[key] !== 'string')
                    ) {
                        var value = object.query.filters[key];
                        var label = object.filterCriteria[key]
                            ? object.filterCriteria[key].chipLabel ||
                              object.filterCriteria[key].label
                            : key;

                        if (object.filterCriteria[key].customFilter) {
                            value = object.filterCriteria[key].customFilter(
                                value
                            );
                        }

                        if (!Array.isArray(value)) {
                            tmp.push({
                                filterKey: key,
                                fieldLabel: label,
                                value: value
                            });
                        } else {
                            value.forEach(function(elem) {
                                tmp.push({
                                    filterKey: key,
                                    fieldLabel: label,
                                    value: elem
                                });
                            });
                        }
                    }
                });
            }
        }

        return tmp;
    },
    replaceEmptyStrings: function(sourceObject, replaceWith = null) {
        // will replace empty strings with null
        let newObject = { ...sourceObject };
        for (let key of Object.keys(newObject)) {
            if (newObject[key] === '') {
                newObject[key] = replaceWith;
            }
        }
        return newObject;
    }
};
